export const orderNo = (o) => o.order_number || o.id.slice(-4);
